import React from 'react';

import { EditableText } from '../../../components/editable-text/EditableText';
import { InlineTimePeriodSelector } from './InlineTimePeriodSelector';
import { InlineTimeSelector } from './InlineTimeSelector';
import { AddStripMenu } from './add-strip-menu';
import { Stripboard } from '../../../app/entities/stripboard';
import { BaseBlock, BaseRow, BlockContainer, Cell } from './styled-strips';

import type { BannerStrip } from '../../../app/entities/strip';

import styles from './break-strip.module.scss';
type BreakStripProps = {
  stripboard: Stripboard;
  strip: BannerStrip;
  style?: any;
  isSelected?: boolean;
  isDragging?: boolean;
  onClick?: (e: React.MouseEvent) => void;
};

export const BreakStrip = React.forwardRef<HTMLTableRowElement, BreakStripProps>(
  ({ stripboard, onClick, isSelected, strip, isDragging, ...draggableProps }, ref) => {
    const handleEdit = (data: any) => {
      stripboard.editStrip(strip._id, { data });
    };

    return (
      <BaseRow
        className={styles['row']}
        ref={ref}
        onClick={onClick}
        data-selected={isSelected}
        data-dragged={isDragging}
        {...draggableProps}
      >
        <Cell
          colSpan={100}
          style={{
            padding: 0,
          }}
        >
          <div className={styles['row-mirror']}>
            <BlockContainer>
              <BaseBlock>
                <EditableText
                  className={styles['block-editable-text']}
                  onSubmit={(text) => handleEdit({ text })}
                  defaultText={'Setup'}
                  maxLength={60}
                >
                  <p className={styles['block-name']}>{strip.data.text}</p>
                </EditableText>
              </BaseBlock>
            </BlockContainer>

            <div className={styles['cell-mirror']}>
              <InlineTimePeriodSelector
                onChange={(estimatedTime) => handleEdit({ estimatedTime })}
                time={strip.data.estimatedTime}
              />
            </div>

            <div className={styles['cell-mirror']}>
              {strip.startTime && (
                <InlineTimeSelector time={strip.startTime || { hour: 0, minute: 0 }} disabled />
              )}
            </div>

            <div className={styles['cell-mirror']}>
              <AddStripMenu
                stripId={strip._id}
                projectId={stripboard.projectId}
                position={strip.position}
                isDark
                stripType="banner"
              />
            </div>
          </div>
        </Cell>
      </BaseRow>
    );
  },
);

BreakStrip.displayName = 'BreakStrip';
